export default defineNuxtPlugin((nuxtApp) => {})
